import React from 'react';
import PropTypes from 'prop-types';

const ImportInfoSection = ({ profileName, fileName, period, style }) => (
  <div style={ style } className="import-info-section" >
    <div className="import-info-section__headers">
      <p>Import Profile</p>
      <p>Period</p>
      <p>Data File</p>
    </div>
    <div className="import-infor-section__data">
      <p>{ profileName }</p>
      <p>{ period }</p>
      <p>{ fileName }</p>
    </div>
  </div>
);

ImportInfoSection.propTypes = {
  profileName: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  period: PropTypes.string.isRequired,
  style: PropTypes.object
};

ImportInfoSection.defaultProps = {
  style: {}
};

export default ImportInfoSection;



// WEBPACK FOOTER //
// ./src/components/importData/comp/importInfoSection/ImportInfoSection.js